if (!customElements.get('closest-stores')) {

  class ClosestStores extends HTMLElement {
    constructor() {
      super();

      this.resultContainers = this.querySelectorAll(".closest-stores__content__result");
      this.zipContainer = this.querySelector(".closest-stores__heading__text button");
      this.textContainer = this.querySelector(".closest-stores__heading__text__result");

      this.locationWidget = document.querySelector(".buff-meganav__location-widget");
      this.actions = null; //doesn't exist initially

      this.mobileBtns = this.querySelectorAll(".closest-stores__content__nav__item");
      this.firstMobileBtn = this.mobileBtns[0];
      this.secondMobileBtn = this.mobileBtns[1];
      this.mobileArrow = this.querySelector(".closest-stores__content__nav__arrow");

      // state
      this.isOpen = false;

      // bind once so add/remove works
      this.onDocMouseDown = this.onDocMouseDown.bind(this);
      this.onDocKeyDown = this.onDocKeyDown.bind(this);

      this.init();
    }

    init() {
      document.addEventListener("location-widget:ordered", (e) => {
          const detail = e.detail;
          this.actions = document.querySelector(".buff-meganav__location-widget__actions");
          
          this.insertStores(detail.closestStore, detail.secondClosest);
          this.insertZip();
          this.insertText(detail.closestStore, detail.secondClosest);
      });

      this.zipContainer?.addEventListener("click", (e) => {
          console.log("click");
        e.preventDefault();
        e.stopPropagation();
        this.isOpen ? this.closeLocationWidget() : this.openLocationWidget();
      });

      this.firstMobileBtn.addEventListener("click", (e) => {
        this.makeResultActive(1);
      })

      this.secondMobileBtn.addEventListener("click", (e) => {
        this.makeResultActive(2);
      });

      this.mobileArrow.addEventListener("click", (e) => {
        if (this.firstMobileBtn.classList.contains("__active")){
          //make second active
          this.makeResultActive(2);
        } else {
          //make first active
          this.makeResultActive(1);
        }
      });
    }

    makeResultActive(index){
      if (index == 1) {
        this.resultContainers[1].parentElement.appendChild(this.resultContainers[1]);
        this.firstMobileBtn.classList.add("__active");
        this.secondMobileBtn.classList.remove("__active");
      } else {
        this.resultContainers[0].parentElement.appendChild(this.resultContainers[0]);
        this.secondMobileBtn.classList.add("__active");
        this.firstMobileBtn.classList.remove("__active");
      }
    }

    openLocationWidget() {
      if (!this.locationWidget || this.isOpen) return;

      if (!this.actions) return;
      

      this.isOpen = true;
      this.locationWidget.classList.add("__clicked-open", "__open-widget");
      this.actions.classList.remove("__inactive");
      

      // listen only while open
      document.addEventListener("mousedown", this.onDocMouseDown);
      document.addEventListener("keydown", this.onDocKeyDown);
      
    }

    closeLocationWidget() {
      if (!this.locationWidget || !this.isOpen) return;

      if (!this.actions) return;

      this.isOpen = false;
      this.locationWidget.classList.remove("__clicked-open", "__open-widget");
      this.actions.classList.add("__inactive");

      document.removeEventListener("mousedown", this.onDocMouseDown);
      document.removeEventListener("keydown", this.onDocKeyDown);
    }

  onDocMouseDown(e) {
    const actionsParent = this.actions.parentElement;

    if (actionsParent && actionsParent.contains(e.target)) return;

    this.closeLocationWidget();
  }

    onDocKeyDown(e) {
      if (e.key === "Escape") {
        this.closeLocationWidget();
      }
    }

    /* -----------------------------
      CONTENT INSERTION
    ------------------------------ */

    insertStores(store1, store2) {
      if (store1?.title && this.resultContainers[0]) {
        const label = document.querySelector(
          `.buff-meganav__location-widget__stores__store[data-store-name='${CSS.escape(store1.title)}'] label`
        );
        if (label) {
          this.resultContainers[0].innerHTML = label.innerHTML;
          this.resultContainers[0].classList.remove("__skeleton");
        }
      }

      if (store2?.title && this.resultContainers[1]) {
        const label = document.querySelector(
          `.buff-meganav__location-widget__stores__store[data-store-name='${CSS.escape(store2.title)}'] label`
        );
        if (label) {
          this.resultContainers[1].innerHTML = label.innerHTML;
          this.resultContainers[1].classList.remove("__skeleton");
        }
      }
    }

    insertZip() {
      const zip = JSON.parse(window.sessionStorage.getItem("userLocation"))?.zipcode;
      if (zip && this.zipContainer) {
        this.zipContainer.innerHTML = zip;
      }
    }

    insertText(store1, store2) {
      if (!this.textContainer) return;

      if (store1?.distance < 40 || store2?.distance < 40) {
        this.textContainer.innerHTML = this.textContainer.dataset.close;
      } else {
        this.textContainer.innerHTML = this.textContainer.dataset.far;
      }

      this.textContainer.classList.remove("__skeleton");
    }
  }
  
  customElements.define('closest-stores', ClosestStores);
}